import React from "react"
import GlobalContextProvider from "./src/Context/GlobalContextProvider"

export const wrapRootElement = GlobalContextProvider
